import { isDefined } from '@yoweb/utils/isDefined';

type ElevatedLabelProps = {
  placeholder?: string;
  label?: string;
  hasFocus: boolean;
  hasValue: boolean;
};

/**
 * Checks if label should be elevated or not
 */
export const isElevatedLabel = ({
  placeholder,
  label,
  hasFocus,
  hasValue,
}: ElevatedLabelProps): boolean => {
  const hasPlaceholder = isDefined(placeholder);
  const hasLabel = isDefined(label);

  const hasOnlyPlaceholder = hasPlaceholder && !hasLabel;
  const hasOnlyLabel = !hasPlaceholder && hasLabel;

  if (!placeholder && !label) return false;
  if (hasValue) return true;
  if (hasFocus) return true;
  if (hasLabel && hasPlaceholder) return true;
  if (hasOnlyLabel && !hasValue && !hasFocus) return false;
  if (hasOnlyPlaceholder) return false;

  return !(!hasValue && (hasOnlyPlaceholder || hasOnlyLabel));
};
